import {
    reactive,
    computed,
    toRefs,
    ref,
    Ref,
    onMounted,
    nextTick,
    ComponentInternalInstance,
    ComponentPublicInstance,
} from "vue";
import { TableStateFilters } from "ant-design-vue/es/table/interface";
import { PageDto, SorterType, Pagination } from "../types/listPageDto";

export function UsePageDto(instance: ComponentInternalInstance | null) {
    const proxy:
        | (ComponentPublicInstance & {
              fetchList?: () => Promise<void>;
              filter?: {};
          })
        | null
        | undefined = instance?.proxy;
    let fetchList: () => Promise<void>;
    let filter: {};

    const listPageDto: PageDto = reactive({
        pageNum: 1,
        pageSize: 20,
        count: 1,
        curPageCount: 1,
        totalPageNum: 1,
    });

    const { pageNum, pageSize, count } = toRefs(listPageDto);

    const pagination = computed(() => ({
        total: count.value,
        current: pageNum.value,
        pageSize: pageSize.value,
    }));

    /**
     *
     * @param pageDto 页码
     * @param filters 过滤条件
     * @param sorter 排序
     */
    const handleTableChange = (
        pageDto: Pagination,
        filters: TableStateFilters,
        sorter: SorterType
    ) => {
        Object.assign(filter, {
            sortField: sorter.field, // 排序的字段
            sortOrder: sorter.order, // 排序的值 正负
            ...filters, // 筛选条件
        });
        Object.assign(listPageDto, {
            pageSize: pageDto?.pageSize,
            pageNum: pageDto?.current,
        });
        if (fetchList) {
            fetchList();
        }
    };
    /**
     * 勾选
     */
    const selectedObj: Ref = ref([]);
    const rowSelection = {
        onChange: (
            selectedRowKeys: (string | number)[],
            selectedRows: Object[]
        ) => {
            console.log("改变", selectedRowKeys);
            selectedObj.value = selectedRows;
        },
        onSelect: (
            record: Object,
            selected: boolean,
            selectedRows: Object[]
        ) => {
            console.log("选择", record, selected, selectedRows);
        },
        onSelectAll: (
            selected: boolean,
            selectedRows: Object[],
            changeRows: Object[]
        ) => {
            console.log("全选", selected, changeRows);
            selectedObj.value = selectedRows;
        },
    };
    // 刷新
    const refresh = () => {
        Object.assign(listPageDto, { pageNum: 1 });
        if (fetchList) {
            fetchList();
        }
    };
    // 重置
    const resetFilter = () => {
        // form重置
        const filterFormRef: any = proxy?.$refs?.filterFormRef;
        if (filterFormRef) {
            filterFormRef.resetFields();
        }
        // 成员/员工筛选项重置
        const userFilterRef: any = proxy?.$refs?.userFilterRef;
        if (userFilterRef) {
            userFilterRef.value = null;
        }
        if (fetchList) {
            fetchList();
        }
    };

    onMounted(() => {
        nextTick(() => {
            if (proxy?.fetchList) {
                fetchList = proxy?.fetchList;
            }
            if (proxy?.filter) {
                filter = proxy?.filter;
            }
        });
    });

    return {
        listPageDto,
        pagination,
        handleTableChange,
        refresh,
        rowSelection,
        selectedObj,
        resetFilter,
    };
}
